import { useState } from 'react';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiKeysApi, apiKeysOptions } from '../api';

import type { ApiKeyOutput } from '../api';

const useApiKeyTable = () => {
  const [open, setOpen] = useState<boolean>(false);
  const queryClient = useQueryClient();
  const [apiKey, setApiKey] = useState<ApiKeyOutput>({
    id: -1,
    lastThreeCharacters: '',
    label: '',
    creationDate: ''
  });

  const { mutate: deleteMutate } = useMutation({
    mutationFn: (id: number) => apiKeysApi.delete(id),
    onSuccess: (_, id) => {
      queryClient.setQueryData<ApiKeyOutput[]>(apiKeysOptions.all(), old =>
        old?.filter(key => key.id !== id)
      );
      setOpen(false);
    }
  });

  const openConfirmModal = (key: ApiKeyOutput) => {
    setOpen(true);
    setApiKey(key);
  };

  const deleteKey = () => {
    deleteMutate(apiKey.id);
  };

  return {
    open,
    setOpen,
    apiKey,
    openConfirmModal,
    deleteKey
  };
};

export default useApiKeyTable;
